module.exports = __webpack_public_path__ + "static/img/020_1.ffe9e1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/020_1.jpg
// module id = QjUR
// module chunks = 1